import React, { useEffect, useState } from "react";
import { Card, Form, Button, Row, Col, Image } from '@themesberg/react-bootstrap';
import { useHistory, useParams } from "react-router-dom";
import api from "../../utils/api";
import Swal from "sweetalert2";
import defaultIcon from "./../../assets/img/brand/logo2.png";

export default function TestimonialForm() {
  const history = useHistory();
  const { id } = useParams();
  const isEdit = id && id !== 'new';

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState('1');
  const [image_url, setImage] = useState(null);
  const [existingUri, setExistingUri] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isEdit) {
      api.get(`/testimonials/${id}`).then(({ data }) => {
        const n = data.data;
        setTitle(n.title || "");
        setDescription(n.description || "");
        setStatus(n.status || '1');
        setExistingUri(n.uri ? n.uri : "");
      });
    }
  }, [id]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (image_url instanceof File) {
        const fd = new FormData();
        fd.append('title', title);
        fd.append('description', description);
        fd.append('status', status);
        fd.append('testimonial_image', image_url);
        if (isEdit) await api.put(`/testimonials/${id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        else await api.post(`/testimonials`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      } else {
        const payload = { title, description: description, status };
        if (isEdit) await api.put(`/testimonials/${id}`, payload);
        else await api.post(`/testimonials`, payload);
      }
      await Swal.fire({ title: 'Success', text: `Testimonials ${isEdit ? 'updated' : 'created'} successfully`, icon: 'success', timer: 1500, showConfirmButton: false, heightAuto: false });
      history.push('/testimonials');
    } catch (e) {
      await Swal.fire({ title: 'Error', text: e?.response?.data?.message || e.message || 'Failed to save', icon: 'error', heightAuto: false });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="shadow-sm">
      <Card.Header>
        <h5 className="mb-0">{isEdit ? 'Edit' : 'Create'} Testimonial</h5>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={onSubmit}>
          <Row>
            <Col md={8}>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control value={title} onChange={(e) => setTitle(e.target.value)} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control as="textarea" rows={8} value={description} onChange={(e) => setDescription(e.target.value)} required />
              </Form.Group>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Image</Form.Label>
                <div style={{ width: '350px' }} className="mb-2">
                  {image_url instanceof File ? (
                    <Image src={URL.createObjectURL(image_url)} thumbnail />
                  ) : (
                    <Image
                      src={
                        existingUri && existingUri !== defaultIcon
                          ? (existingUri.startsWith('http') ? existingUri : `/uploads/${existingUri}`)
                          : defaultIcon
                      }
                      onError={(e) => {
                        if (e.target.src !== defaultIcon) {
                          e.target.src = defaultIcon;
                        }
                      }}
                      thumbnail
                    />
                  )}
                </div>
                <Form.Control type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            <Button variant="secondary" className="me-2" onClick={() => history.push('/testimonials')}>Cancel</Button>
            <Button type="submit" variant="primary" disabled={saving}>{saving ? 'Saving...' : 'Save'}</Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}


